import React, { useEffect, useState, } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import AddAdmin from './component/AddAdmin';
import ChnagePassword from './component/ChnagePassword';

import { adminLisitingRequest, deleteAdmin } from './redux/adminDispatcher';
import { imageBaseUrls } from '../../constant/ApiUrls';
import dummyProfileImage from "./../../components/assets/image/dummy-profile-image.png"

function AdminListingTable({ adminListing }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const adminListingHeading = [
        {
            field: "id", headerName: "NO", width: 40,
            renderCell: (params) =>
                params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
        },
        {
            field: "image",
            headerName: "Profile",
            width: 80,
            sortable: false,

            renderCell: (params) => (
                <img
                    src={params.value ? `${imageBaseUrls(params.value)}` : dummyProfileImage}
                    alt="Profile"
                    style={{ width: 40, height: 40, borderRadius: "50%" }}
                />
            ),
        },
        {
            field: 'name',
            headerName: 'Admin Name',
            width: 200,
        },
        {
            field: 'email',
            headerName: 'Admin Email',
            width: 350,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 350,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center', height: '100%' }}>
                      


                         <ChnagePassword
                            editMode={true}
                            adminData={params.row}
                        />

                          <AddAdmin
                            buttonLabel="Edit"
                            editMode={true}
                            adminData={params.row}
                        />

                        <button
                            onClick={() => handleDelete(params.row)}
                            style={{
                                backgroundColor: '#F44336',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                fontSize: '10px',
                                width: '60px',
                                height: '24px',
                                padding: '2px 5px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            Delete
                        </button>
                    </div>
                );
            },
        },
    ];

    const handleDelete = (row) => {
        Swal.fire({
            html: `Are you sure?<br>You want to delete bank "${row.name}"`,
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: `Yes, Delete`,
            showCloseButton: true,
            cancelButtonColor: 'gray',
            confirmButtonColor: '#4f83df',
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                dispatch(deleteAdmin(row.id));
            }
        });
    };


    useEffect(() => {
        dispatch(adminLisitingRequest(page + 1, pageSize,));

    }, [dispatch, location.pathname, page, pageSize,]);

    return (
        <Paper sx={{ height: '95%', width: '100%' }}>
            <div style={{ padding: '10px', justifyItems: 'end' }}>
                <AddAdmin buttonLabel={"Add Admin"} />
            </div>





            <DataGrid
                rows={adminListing.adminListing || []}
                columns={adminListingHeading || []}
                rowCount={adminListing.totalAdmin || 0}
                paginationModel={{ page, pageSize }}
                paginationMode="server"
                onPaginationModelChange={({ page, pageSize }) => {
                    console.log("pagination----", page, pageSize);
                    setPage(page);
                    setPageSize(pageSize);
                }}
                pageSizeOptions={[10, 25, 50]}
                rowHeight={60}
                loading={adminListing.loading}
                checkboxSelection={false}
                sx={{ border: 0 }}


            />

        </Paper>
    );
}

const mapStateToProps = (state) => {
    return {
        adminListing: state.adminReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        adminLisitingRequest: () => dispatch({ type: 'GET_ADMIN_REQUEST' }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminListingTable);
